











































































import { Vue, Component } from 'vue-property-decorator'
import { Action, State, Getter } from 'vuex-class'
import * as tool from './../../utils/tool'
import { TeaConfig } from './../../const/dashboard'
import {
  SHOW_BEST_PRACTICE_CODE,
  HIDE_BEST_PRACTICE_CODE,
  BEST_PRACTICE_ENTRY_SHOW_TRUE,
  BEST_PRACTICE_ENTRY_SHOW_FALSE,
  getBPEntryKey,
} from './../../const/promotional'

@Component({
  name: 'BestPractice',
})
export default class BestPractice extends Vue {
  TeaConfig = TeaConfig;
  switchDisabled = false; // disable "hide" button until network request finishes

  @Getter('account/accountInfo') accountInfo: any
  @State(state => state.bestPracticeStatus) bestPracticeStatus: number;
  @Action('initBestPracticeStatus') initBestPracticeStatus: Function;
  @Action('updateBestPracticeStatus') updateBestPracticeStatus: Function;

  get hideSwitchOn(): boolean {
    return this.bestPracticeStatus === HIDE_BEST_PRACTICE_CODE
  }

  mounted() {
    this.initBestPracticeStatus()
  }

  copyURL() {
    tool.accessPC()
  }

  async hideSwitchChangeHandler(checked: boolean) {
    this.switchDisabled = true // prevent user from spamming the button
    try {
      await this.updateBestPracticeStatus(
        checked ? HIDE_BEST_PRACTICE_CODE : SHOW_BEST_PRACTICE_CODE,
      )
      localStorage.setItem(
        getBPEntryKey(this.accountInfo.aadvid),
        checked ? BEST_PRACTICE_ENTRY_SHOW_FALSE : BEST_PRACTICE_ENTRY_SHOW_TRUE,
      )
    } catch (e) {
      console.log(e)
    } finally {
      this.switchDisabled = false
    }
  }
}

